var _window$digitalData, _window$digitalData$p, _window$digitalData$p2;

import csbMedLogic from './csb-medical.js';
import ifpMedLogic from './ifp-medical.js';
import ifpDenLogic from './ifp-dental.js';
var isCignaCore;

if ((_window$digitalData = window.digitalData) === null || _window$digitalData === void 0 ? void 0 : (_window$digitalData$p = _window$digitalData.page) === null || _window$digitalData$p === void 0 ? void 0 : (_window$digitalData$p2 = _window$digitalData$p.pageInfo) === null || _window$digitalData$p2 === void 0 ? void 0 : _window$digitalData$p2.isCore) {
  isCignaCore = window.digitalData.page.pageInfo.isCore;
}

var currentHost = window.location.hostname;
var folderName = window.location.pathname;
var siteName;

if (currentHost.indexOf('campaigns') > -1) {
  siteName = 'campaigns-cigna-com';
} else if (currentHost.indexOf('cigna') > -1 && isCignaCore) {
  siteName = 'www-cigna-com';
} else if (currentHost.indexOf('sites') > -1) {
  siteName = 'sites-cigna-com';
} else {
  siteName = '';
}

var jsonFileName;

if (folderName.match(/(supplemental|csb|medicare-campaigns)/gm)) {
  jsonFileName = 'csb-medical';

  if (siteName === '' && folderName.startsWith('/medicare-campaigns')) {
    siteName = 'www-cigna-com';
  }
} else if (folderName.match(/(dental)/gm)) {
  jsonFileName = 'ifp-dental';
} else {
  jsonFileName = 'ifp-medical';
}

var jsonPath = "/static/".concat(siteName, "/json/campaigns/").concat(jsonFileName, ".json");
export default (function () {
  if (siteName.length) {
    fetch(jsonPath).then(function (response) {
      return response.json();
    }).then(function (data) {
      var campaignData = data;

      if (folderName.match(/(supplemental|csb)/gm)) {
        csbMedLogic(campaignData);
      } else if (folderName.match(/(dental)/gm)) {
        ifpDenLogic(campaignData);
      } else {
        ifpMedLogic(campaignData);
      }
    });
  }
});